import React, {
  useCallback,
  useRef,
  Fragment,
  useContext,
  useEffect,
  useState,
} from 'react';
import {
  makeStyles,
  withStyles,
  Divider,
  Grid,
  Popover,
  Typography,
} from '@material-ui/core';
import { goDial, openLink, shareApi } from '../../util/utilNative';
import copyToClipboard from 'copy-to-clipboard';
import EmblaCarouselReact from 'embla-carousel-react';
import Popup from 'reactjs-popup';

import Reservation from '../../../asset/img/btn_reserve.png';
import Navigation from '../../../asset/img/btn_find_way.png';
import iconSMS from '../../../asset/img/btn_sms.png';
import ArrowRight from '../../../asset/img/icon_arrow_right.svg';
import Copy from '../../../asset/img/icon_copy.svg';
import IconShare from '../../../asset/img/icon_share.svg';

import NaverMaps from '../../map/NaverMaps';
import GoogleMaps from '../../map/GoogleMaps';
import Carousel from '../../carousel/Carousel';
import DataContext from '../../data/DataContext';
import SMS from '../../dialog/SMS.js';
import { ToggleButtonGroup } from '@material-ui/lab';
import { ToggleButton } from '@material-ui/lab';
import { borderRadius, display, textAlign } from '@material-ui/system';

const styles = (theme) => ({
  root: {
    position: 'relative',
    letterSpacing: '-0.0313rem',
    margin: '0.375rem 0 0.375rem 1rem',
    zIndex: 10,
  },
  carousel: {
    // padding: "0px 6px"
  },
  list: {
    display: 'flex',
    alignItems: 'stretch',
    width: '100%',
    'user-select': 'none',
    '-webkit-touch-callout': 'none',
    '-khtml-user-select': 'none',
    '-webkit-tap-highlight-color': 'transparent',
  },
  listitem: {
    padding: '0 0 0.375rem 0.375rem',
    '&:first-child': {
      padding: '0 0 0.375rem 0',
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '16.25rem',
    height: '100%',
    flex: 'auto',
    background: '#fff',
    // border: "1px solid #d7d7d7",
    borderRadius: '0.375rem',
    textAlign: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    boxShadow: '0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0.1)',
    position: 'relative',
  },
  map: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  title: {
    height: 'auto',
    minHeight: '2.8125em', // "45px",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: 'inherit',
    padding: '1.25rem 1.25rem 0.7188rem',
    justifyContent: 'space-between',
  },
  titleName: {
    color: '#000',
    fontSize: theme.font.size15, // "15px",
    fontFamily: 'inherit',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    marginBottom: '0.25rem',
  },
  titleRow: {
    marginBottom: '0.4375rem',
  },
  titleDistance: {
    display: 'flex',
    fontSize: theme.font.size12,
    color: '#ea1917', //"#da0f47",
    minWidth: '4.063rem',
    fontFamily: 'inherit',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    alignItems: 'center',
  },
  shareIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  shareIconButton: {
    background: 'none',
    border: 'none',
  },
  clipboardCopy: {
    fontSize: theme.font.size11,
    fontWeight: 'bold',
  },
  address: {
    fontSize: theme.font.size12,
    color: '#000',
    textAlign: 'left',
    // padding: "0px 10px 0px 0px",
    // marginRight: "10px",
    // height: "auto" // "3.125em", // "50px"
    fontFamily: 'inherit',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    // marginBottom:"11.5px",
  },
  info: {
    height: '1.25rem',
    display: 'flex',
    fontSize: theme.font.size11,
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0.625rem',
  },
  label: {
    fontSize: theme.font.size12,
    color: '#555',
    textAlign: 'left',
    padding: '0rem',
    borderBotton: 'none',
    // marginRight: "8px",
    minWidth: '18%',
    fontFamily: 'inherit',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    marginBottom: '0.125rem',
  },
  infoValue: {
    fontSize: theme.font.size12,
    color: '#000',
    // textAlign: "right",
    textAlign: 'justify',
    padding: '0px',
    borderBotton: 'none',
    fontFamily: 'inherit',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    maxWidth: '82%',
  },
  buttonGroup: {
    // borderTop: "1px solid #e1e1e1",
    // borderRadius: "0 0 12px 12px",
    // minHeight: "3.125rem",
    // background: "#fafafa",
    paddingBottom: '0.8125rem',
  },
  buttonGroupItem: {
    alignItems: 'center',
    display: 'flex',
    width: '100%',
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '2.5rem',
    width: '100%',
    padding: 0,
    fontSize: theme.font.size14,
    background: '#ea1917', //"#da0f47",
    color: '#fff',
    fontFamily: 'inherit',
    fontWeight: 'bold',
    // outline: '0 none',
    border: '0',
    borderRadius: '0.375rem',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    margin: '0.1875rem 1rem',
    // "&:active": {
    //   background: "rgba(38, 38, 38, 0.1)",
    // },
  },
  buttonDefault: {
    background: '#eee',
    color: '#000',
  },
  buttonDisabled: {
    color: 'rgba(38, 38, 38, 0.4)',
  },
  buttonDivider: {
    background: '#e1e1e1',
    height: '1rem',
    width: '0.0625rem',
    minWidth: '0.0625rem',
    padding: '1rem 0 0 0',
  },
  infoBody: {
    // margin: "0 0 25px 0",
    flexGrow: 1,
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    margin: '0.7188rem 0',
    minWidth: '100%',
  },
  infoMultilineContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    padding: '0rem 1.25rem',
  },
  infoMultilineItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    margin: '0 0 0 0 ',
    justifyContent: 'space-between',
  },
  infoIcon: {
    width: '1em', // "16px",
    height: '1em', // "16px",
    minWidth: '1em', // "16px",
    minHeight: '1em', // "16px",
    margin: '0.125rem 0.5rem 0 1.1875rem', // ".125em .5em 0 1.1875em"
  },
  phoneCallLink: {
    textDecoration: 'none',
    border: 'none',
    // outline: '0 none',
    color: '#262626',
    fontSize: theme.font.size13,
    background: 'none',
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 0.125rem',
  },
  externalDivider: {
    height: '1.25rem',
    alignSelf: 'center',
  },
  externalButton: {
    color: '#555',
    fontWeight: 'bold',
    fontSize: theme.font.size14,
    flex: 1,
    border: 'none',
    padding: 0,
    background: 'transparent',
    // "&:active": {
    //   background: "rgba(38, 38, 38, 0.1)",
    // },
  },
  buttonLeft: {
    borderRadius: '0rem 0rem 0rem 0.75rem',
  },
  buttonRight: {
    borderRadius: '0rem 0rem 0.75rem 0rem',
  },
  buttonMiddle: {
    borderRadius: '0rem',
  },
  leftContainer: {
    justifyContent: 'flex-start',
  },
  message: {
    fontSize: theme.font.size14,
    margin: '0.375rem 1rem 0.375rem 1rem',
    flexWrap: 'wrap',
    color: theme.color.message.color,
    zIndex: 10,
    wordWrap: 'break-word',
  },
  leftMessage: {
    width: '75%',
  },
  text: {
    margin: '0.125rem 0rem 0.375rem 0rem',
    borderRadius: '0.625rem',
    backgroundColor: theme.color.message.background,
    minHeight: '2.75rem',
    lineHeight: '1.43',
    padding: '0.75rem 1rem',
  },
  options: {
    alignItems: 'center',
    margin: '0rem 0rem 12px 0rem',
    border: 'none',
    background: 'none',
  },
  optionButton: {
    border: '0rem',
    fontSize: '0.875rem',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.14',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#666  ',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    padding: '0 0 0.3125rem 0',
    margin: '0 16px 0 0',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    height: '1.75rem',
  },
  btnSelected: {
    background: 'none !important',
    border: '0rem',
    fontSize: '0.9375rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.07',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000 !important',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    borderBottom: '0.125rem solid #ea1917',
    borderRadius: 0,
  },
  mapBanner: {
    position: 'absolute',
    zIndex: '1',
    height: '1.25rem',
    borderRadius: '0.25rem',
    color: '#fff',
    font: 'inherit',
    padding: '0.125rem 0.375rem',
    margin: '0.75rem',
    fontSize: '0.6875rem',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    width: 'max-content',
  },
  mapBannerShop: {
    background: '#ea1917', //"#da0f47",
  },
  mapBannerCenter: {
    background: '#222',
  },
  callIcon: {
    width: '0.75rem',
    height: '0.75rem',
  },
  callValue: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  copyIcon: {
    // position: "relative",
    width: '0.75rem',
    height: '0.75rem',
    margin: '0 2px',
  },
  copyIconButton: {
    background: 'none',
    border: 'none',
  },
  verticalCenter: {
    verticalAlign: 'middle',
    position: 'relative',
    lineHeight: 1,
  },
  copyClipDiv: {
    position: 'absolute',
    width: 'fit-content',
    borderRadius: '0.375rem',
    backgroundColor: theme.color.button.background_grey,
    fontSize: '0rem',
  },
  dots: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0rem 0rem 0rem',
  },
  dot: {
    width: '0.375rem',
    height: '0.375rem',
    borderRadius: '62.4375rem',
    margin: '0rem 2px',
    backgroundColor: '#666',
    // opacity: '0.2',
    transition: 'all, .5s, ease-in-out',
    padding: '0',
    border: 'none',
  },
  dotActive: {
    width: '1.125rem',
    height: '0.375rem',
    background: '#000',
    border: '62.4375rem',
    opacity: '1',
  },
  infoSaturdayItem: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    width: '100%',
  },
  infoSaturday: {
    fontSize: '0.75rem',
    color: '#ea1917',
    textAlign: 'right',
  },
});

function makeNavigateURL(centerName, lat, lng) {
  const url =
    'http://' +
    'map.naver.com/?pathType=1&eText=' +
    centerName +
    '&elng=' +
    lng +
    '&elat=' +
    lat;
  return url;
}

const btm_map = { kr_all: '모두보기', kr_center: '서비스센터', kr_shop: '베스트샵' };
const btn_order = [
  { label: '모두보기', lo_type: 'kr_all' },
  { label: '베스트샵', lo_type: 'kr_shop' },
  { label: '서비스센터', lo_type: 'kr_center' },
];

const LOCarousel = withStyles(styles)((props) => {
  const { classes, data, selectedLoType, ariaLabel, parentFunc } = props;
  const [embla, setEmbla] = useState(null);
  const [slide, setSlide] = useState(0);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const setScrollStatus = () => {
    if (embla) {
      setSlide(embla.selectedScrollSnap());
      setCanScrollPrev(embla.canScrollPrev());
      setCanScrollNext(embla.canScrollNext());
    }
  };

  const options = { align: 'start', dragFree: true, containScroll: true, startIndex: 0 };
  useEffect(() => {
    if (embla) {
      setCanScrollPrev(embla.canScrollPrev());
      setCanScrollNext(embla.canScrollNext());

      embla.on('select', () => {
        setScrollStatus();
      });
      embla.on('resize', () => {
        setScrollStatus();
      });
    }

    //remove below line due to https://github.com/davidcetinkaya/embla-carousel-react/issues/13
    //return () => embla && embla.destroy();
  }, [embla, data]);

  useEffect(() => {
    if (!data || !embla) return;
    embla.reInit();
    embla.scrollTo(0);
  }, [data]);

  useEffect(() => {
    if (!embla) {
      return;
    }
    embla.reInit();
    embla.scrollTo(0);
  }, [selectedLoType]);

  const renderDots = useCallback(() => {
    if (embla) {
      const slide = embla.selectedScrollSnap();
      return (
        <div className={classes.dots}>
          {embla.slideNodes().length === 4
            ? embla.scrollSnapList().map((snap, index) => (
                <button
                  key={`embla-carousel-${index}`}
                  active={index === slide ? 'true' : 'false'}
                  onClick={() => embla.scrollTo(index)}
                  // hidden={index < slide - 3 || index > slide + 3}
                  // role={'button'}
                  className={[
                    classes.dot,
                    index === slide ? classes.dotActive : null,
                  ].join(' ')}
                  aria-label={`${index === slide ? '선택됨,' : ''} ${
                    ariaLabel ? ariaLabel : ''
                  } ${index + 1}번째 슬라이드 보기, ${index + 1} / 4`}
                />
              ))
            : embla.scrollSnapList().map((snap, index) => (
                <button
                  key={`embla-carousel-${index}`}
                  active={index === slide ? 'true' : 'false'}
                  onClick={() => embla.scrollTo(index)}
                  // hidden={index < slide - 2 || index > slide + 2}
                  // role={'button'}
                  className={[
                    classes.dot,
                    index === slide ? classes.dotActive : null,
                  ].join(' ')}
                  aria-label={`${index === slide ? '선택됨,' : ''} ${
                    ariaLabel ? ariaLabel : ''
                  } ${index + 1}번째 슬라이드 보기, ${index + 1} / ${
                    embla.scrollSnapList().length
                  }`}
                />
              ))}
        </div>
      );
    }
    return null;
  }, [embla]);

  const mapData = data;
  const [openPopup, setOpenPopup] = useState(mapData.map(() => false));
  const [popupTimer, setPopupTimer] = useState(null);
  const context = useContext(DataContext);
  const daymap = {
    weekday_hour: '평일',
    saturday_hour: '토요일',
    sunday_hour: '일요일',
  };

  const handlePhoneCallClick = (telNum) => {
    if (!embla.clickAllowed()) {
      return;
    }
    goDial(telNum);
  };

  const openCopiedPopup = (index) => {
    if (openPopup[index]) return;

    setOpenPopup((prev) => {
      prev[index] = !prev[index];
      return [...prev];
    });
    const timerId = setTimeout(() => {
      setOpenPopup((prev) => {
        prev[index] = !prev[index];
        return [...prev];
      });
      setPopupTimer(null);
    }, 2000);
    setPopupTimer(timerId);
  };

  const handlePopoverClose = (index) => {
    if (!openPopup[index]) return;

    if (popupTimer !== null) {
      clearTimeout(popupTimer);
      setPopupTimer(null);
    }
    setOpenPopup((prev) => {
      prev[index] = !prev[index];
      return [...prev];
    });
  };

  useEffect(() => {
    return () => {
      if (popupTimer !== null) {
        clearTimeout(popupTimer);
      }
    };
  }, []);

  const handleNavigateClick = (button) => {
    const centerName = encodeURIComponent(button.parameters.dest);
    const lat = button.parameters.latitude;
    const lng = button.parameters.longitude;
    const url = makeNavigateURL(centerName, lat, lng);
    openLink(context, 'external', url);
  };

  const handleSMSOpen = (centerName, centerSeq, phoneNumber) => {
    parentFunc.setSMSInfo(() => {
      return {
        SMSOpen: true,
        centerName: centerName,
        centerSeq: centerSeq,
        phoneNumber: phoneNumber,
      };
    });
  };

  const handleButtonClick = (item, buttonIndex) => {
    const button = item.lo_info.buttons[buttonIndex];
    if (!embla.clickAllowed()) {
      return;
    }
    switch (button.parameters.action) {
      case 'get_direction':
        handleNavigateClick(button);
        break;
      case 'send_lms':
        handleSMSOpen(item.name, item.center_seq, button.parameters.phone_number);
        break;
      case 'external':
        const targetUrl =
          context.userAgent.deviceType === 'mobile'
            ? button.parameters.mobile_url
            : button.parameters.url;
        openLink(context, 'external', targetUrl, item.event_action);
        break;
      default:
    }
  };

  const contentStyle = {
    background: '#fff',
    boxShadow: '0 0.25rem 0.25rem 0 rgba(0, 0, 0, 0.3)',
    // boxShadow: "0 0.25rem 0.25rem 0",
    borderRadius: '0.25rem',
    color: 'rgba(0, 0, 0, 0.87)',
    // color: "#000",
    fontSize: '.6875rem',
    fontWeight: 'bold',
    padding: '0.3125rem',
    // outline: 0,
    zIndex: 10,
  };
  // const overlayStyle = { background: 'rgba(0,0,0,0.5)' };
  // const arrowStyle = { color: '#000' };
  const krShop = mapData
    .filter((value) => value.lo_type === 'kr_shop')
    .filter((value, index) => {
      return index < 5;
    });
  const krCenter = mapData
    .filter((value) => value.lo_type === 'kr_center')
    .filter((value, index) => {
      return index < 5;
    });

  const krAllData = [...krShop, ...krCenter];
  krAllData.sort((a, b) => {
    return (
      Number(a.lo_info.distance.slice(0, -2)) - Number(b.lo_info.distance.slice(0, -2))
    );
  });

  // console.log('krAllData :::::::', krAllData);

  return (
    <EmblaCarouselReact emblaRef={setEmbla} options={options}>
      <div className={classes.list}>
        {krAllData.map((item, index) => {
          const saturdayHour = item.lo_info.opening_time.saturday_hour;
          let tablerows = [];
          for (let daykey in daymap) {
            let opentimeinfo = item.lo_info.opening_time[daykey];
            let tableinfo = {
              label: daymap[daykey],
            };

            tableinfo['value'] = '휴무';
            if (opentimeinfo) {
              tableinfo['value'] = opentimeinfo;
            }
            tablerows.push(tableinfo);
          }

          return selectedLoType === 'kr_all' ? (
            <div key={`lo-list-item-${index}`} className={classes.listitem}>
              <div className={classes.card}>
                <div
                  className={`${classes.mapBanner} ${
                    item.lo_type === 'kr_shop'
                      ? classes.mapBannerShop
                      : classes.mapBannerCenter
                  }`}
                >
                  {btm_map[item.lo_type]}
                </div>
                {context.countryCode === 'us' ? (
                  <GoogleMaps
                    id={`googleMaps${index}`}
                    title={item.name}
                    defaultCenter={{
                      lat: item.lo_info.location.latitude,
                      lng: item.lo_info.location.longitude,
                    }} // 지도 초기 위치
                    defaultZoom={16} // 지도 초기 확대 배율
                    countryCode={context.countryCode}
                    style={{
                      width: '100%', // 구글맵 가로 길이
                      height: '7.5rem', // 구글맵 세로 길이
                      borderRadius: '0.375rem 0.375rem 0rem 0rem',
                    }}
                  />
                ) : (
                  <NaverMaps
                    id={`naverMaps${index}`}
                    title={item.lo_info.name}
                    latitude={item.lo_info.location.latitude}
                    longitude={item.lo_info.location.longitude}
                    lotype={item.lo_type}
                    defaultZoom={16} // 지도 초기 확대 배율
                    countryCode={context.countryCode}
                    style={{
                      width: '100%', // 네이버지도 가로 길이
                      height: '7.5rem', // 네이버지도 세로 길이
                      borderRadius: '0.375rem 0.375rem 0rem 0rem',
                    }}
                  />
                )}

                <Grid container className={classes.title}>
                  <Grid container className={classes.titleRow}>
                    <Grid
                      xs={context.userAgent.deviceType === 'mobile' ? 6 : 12}
                      item
                      className={classes.titleDistance}
                    >
                      {item.lo_info && item.lo_info.distance}
                    </Grid>
                    {context.userAgent.deviceType === 'mobile' && (
                      <Grid xs={6} item className={classes.shareIcon}>
                        <button
                          className={classes.shareIconButton}
                          onClick={() => {
                            let shareUrl =
                              item.lo_type === 'kr_shop'
                                ? `https://www.lge.co.kr/bestshop/homepage-${item.lo_info.shop_id}?status=lg&chatbot=y`
                                : `https://www.lge.co.kr/support/find-service-center-${item.lo_info.center_seq}?share=t`;
                            shareApi(context, item.lo_info.name, '', shareUrl);
                          }}
                        >
                          <img src={IconShare} alt="공유하기" />
                        </button>
                      </Grid>
                    )}
                  </Grid>
                  <Grid item className={classes.titleName}>
                    {item.lo_info && item.lo_info.name}
                  </Grid>

                  <div className={classes.address}>
                    <span>
                      {item.lo_info.address.depth_1} {item.lo_info.address.depth_2}
                    </span>
                    <span className={classes.verticalCenter}>
                      <Popup
                        open={openPopup[index]}
                        onOpen={() => {
                          let addressTxt = `${item.lo_info.address.depth_1} ${item.lo_info.address.depth_2}`;
                          if (window?.navigator?.clipboard?.writeText) {
                            window.navigator.clipboard.writeText(addressTxt);
                          } else {
                            copyToClipboard(addressTxt);
                          }
                          openCopiedPopup(index);
                        }}
                        trigger={
                          <button className={classes.copyIconButton}>
                            <img src={Copy} className={classes.copyIcon} alt="복사하기" />
                          </button>
                        }
                        position="bottom center"
                        close={openPopup[index]}
                        contentStyle={contentStyle}
                        // overlayStyle={overlayStyle}
                        // arrowStyle={arrowStyle}
                      >
                        {context.string.chat.clipboardCopied}
                      </Popup>
                    </span>
                    {openPopup[index] && (
                      <div
                        className={classes.copyClipDiv}
                        role="alert"
                        aria-live="assertive"
                      >
                        {context.string.chat.clipboardCopied}
                      </div>
                    )}
                  </div>
                </Grid>

                <div className={classes.infoBody}>
                  <Divider component={'div'} variant="middle" color="#eee" disabled />
                  <div className={classes.infoContainer} role={'text'}>
                    <div className={classes.infoMultilineContainer}>
                      {/* 서비스센터 찾기 카드에 출력되는 문구 변경 25-03 */}
                      {(saturdayHour === '휴무' && item.lo_type === 'kr_center') ||
                      item.lo_type === 'kr_shop'
                        ? tablerows.map((row, index) => {
                            return (
                              <Grid
                                container
                                key={`g1_${index}`}
                                className={classes.infoMultilineItem}
                              >
                                <Grid item className={classes.label}>
                                  {row.label}
                                </Grid>
                                <Grid item className={classes.infoValue}>
                                  {row.value}
                                </Grid>
                              </Grid>
                            );
                          })
                        : tablerows.map((row, index) => {
                            return (
                              <Grid
                                container
                                key={`g1_${index}`}
                                className={classes.infoMultilineItem}
                              >
                                <Grid item className={classes.label}>
                                  {row.label}
                                </Grid>
                                <Grid item className={classes.infoValue}>
                                  {row.value}
                                </Grid>
                                {row.label === '토요일' ? (
                                  <div className={classes.infoSaturdayItem}>
                                    <Grid item>&nbsp;</Grid>
                                    <Grid item className={classes.infoSaturday}>
                                      * 매월 4번째 토요일 휴무
                                    </Grid>
                                  </div>
                                ) : (
                                  ''
                                )}
                              </Grid>
                            );
                          })}
                    </div>
                  </div>
                  <Divider component={'div'} variant="middle" color="#eee" disabled />
                  <div className={classes.infoContainer} role={'text'}>
                    <div className={classes.infoMultilineContainer}>
                      <Grid
                        container
                        key={`g2_${index}`}
                        className={classes.infoMultilineItem}
                      >
                        <Grid item className={classes.label}>
                          전화
                        </Grid>
                        <Grid
                          item
                          className={[classes.infoValue, classes.callValue].join(' ')}
                        >
                          {item.lo_info.phone_number}{' '}
                          {context.userAgent.deviceType === 'mobile' &&
                            item.lo_info &&
                            item.lo_info.phone_number && (
                              // <>
                              //   <a className={classes.phoneCallLink} href={`tel:${item.lo_info.phone_number}`}>{item.lo_info.phone_number}</a>
                              //   <img src={ArrowRight} className={classes.callIcon} />
                              // </>
                              <button
                                type="button"
                                className={classes.phoneCallLink}
                                onClick={() => {
                                  handlePhoneCallClick(item.lo_info.phone_number);
                                }}
                              >
                                <img
                                  src={ArrowRight}
                                  className={classes.callIcon}
                                  alt="전화하기"
                                />
                              </button>
                            )}
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        key={`g3_${index}`}
                        className={classes.infoMultilineItem}
                      >
                        <Grid item className={classes.label}>
                          주차
                        </Grid>
                        <Grid item className={classes.infoValue}>
                          {item.lo_type === 'kr_shop'
                            ? item.lo_info.parking
                            : item.lo_info.parking_detail}
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </div>
                <Grid container className={classes.buttonGroup}>
                  {item.lo_info.buttons &&
                    item.lo_info.buttons.map((button, index) => {
                      let buttonIcon = '';
                      switch (button.label) {
                        case '길찾기':
                          buttonIcon = Navigation;
                          break;
                        case '방문예약':
                        case '매장상담신청':
                          buttonIcon = Reservation;
                          break;
                        case '문자로받기':
                          buttonIcon = iconSMS;
                          break;
                        default:
                          buttonIcon = null;
                      }

                      return (
                        <Grid
                          item
                          key={`g4_${index}`}
                          // xs={12 / item.lo_info.buttons.length}
                          className={classes.buttonGroupItem}
                        >
                          {/* <Divider
                    className={classes.buttonDivider}
                    orientation="horizontal"
                    hidden={index === 0}
                    component={"div"}
                    disabled
                  /> */}
                          <button
                            type="button"
                            className={[
                              classes.button,
                              index !== 0 && classes.buttonDefault,
                              // index === 0 &&
                              //   item.lo_info.buttons.length !== 1 &&
                              //   classes.buttonLeft,
                              // index === item.lo_info.buttons.length - 1 &&
                              //   item.lo_info.buttons.length !== 1 &&
                              //   classes.buttonRight,
                              // index !== 0 &&
                              // index !== item.lo_info.buttons.length - 1 &&
                              // item.lo_info.buttons.length > 2
                              //   ? classes.buttonMiddle
                              //   : "",
                              (context.conversationEnd ||
                                button.parameters.enable === 'N') &&
                                classes.buttonDisabled,
                            ].join(' ')}
                            disabled={
                              context.conversationEnd || button.parameters.enable === 'N'
                            }
                            onClick={() => handleButtonClick(item, index)}
                            aria-label={`${
                              button.parameters.action.toLowerCase() === 'external' ||
                              button.parameters.action.toLowerCase() === 'get_direction'
                                ? context.string.aria.external + ','
                                : ''
                            } ${button.label}`}
                          >
                            {button.label}
                          </button>
                        </Grid>
                      );
                    })}
                </Grid>
              </div>
            </div>
          ) : (
            <></>
          );
        })}

        {mapData.map((item, index) => {
          // if (selectedLoType !== item.lo_type && selectedLoType !== 'kr_all') return;
          const saturdayHour = item.lo_info.opening_time.saturday_hour;

          let tablerows = [];
          for (let daykey in daymap) {
            let opentimeinfo = item.lo_info.opening_time[daykey];
            let tableinfo = {
              label: daymap[daykey],
            };

            tableinfo['value'] = '휴무';
            if (opentimeinfo) {
              tableinfo['value'] = opentimeinfo;
            }
            tablerows.push(tableinfo);
          }

          return selectedLoType === item.lo_type && selectedLoType !== 'kr_all' ? (
            <div key={`lo-list-item-${index}`} className={classes.listitem}>
              <div className={classes.card}>
                <div
                  className={`${classes.mapBanner} ${
                    item.lo_type === 'kr_shop'
                      ? classes.mapBannerShop
                      : classes.mapBannerCenter
                  }`}
                >
                  {btm_map[item.lo_type]}
                </div>
                {context.countryCode === 'us' ? (
                  <GoogleMaps
                    id={`googleMaps${index}`}
                    title={item.name}
                    defaultCenter={{
                      lat: item.lo_info.location.latitude,
                      lng: item.lo_info.location.longitude,
                    }} // 지도 초기 위치
                    defaultZoom={16} // 지도 초기 확대 배율
                    countryCode={context.countryCode}
                    style={{
                      width: '100%', // 구글맵 가로 길이
                      height: '7.5rem', // 구글맵 세로 길이
                      borderRadius: '0.375rem 0.375rem 0rem 0rem',
                    }}
                  />
                ) : (
                  <NaverMaps
                    id={`naverMaps${index}`}
                    title={item.lo_info.name}
                    latitude={item.lo_info.location.latitude}
                    longitude={item.lo_info.location.longitude}
                    lotype={item.lo_type}
                    defaultZoom={16} // 지도 초기 확대 배율
                    countryCode={context.countryCode}
                    style={{
                      width: '100%', // 네이버지도 가로 길이
                      height: '7.5rem', // 네이버지도 세로 길이
                      borderRadius: '0.375rem 0.375rem 0rem 0rem',
                    }}
                  />
                )}

                <Grid container className={classes.title}>
                  <Grid container className={classes.titleRow}>
                    <Grid
                      xs={context.userAgent.deviceType === 'mobile' ? 6 : 12}
                      item
                      className={classes.titleDistance}
                    >
                      {item.lo_info && item.lo_info.distance}
                    </Grid>
                    {context.userAgent.deviceType === 'mobile' && (
                      <Grid xs={6} item className={classes.shareIcon}>
                        <button
                          className={classes.shareIconButton}
                          onClick={() => {
                            let shareUrl =
                              item.lo_type === 'kr_shop'
                                ? `https://www.lge.co.kr/bestshop/homepage-${item.lo_info.shop_id}?status=lg&chatbot=y`
                                : `https://www.lge.co.kr/support/find-service-center-${item.lo_info.center_seq}?share=t`;
                            shareApi(context, item.lo_info.name, '', shareUrl);
                          }}
                        >
                          <img src={IconShare} alt="공유하기" />
                        </button>
                      </Grid>
                    )}
                  </Grid>
                  <Grid item className={classes.titleName}>
                    {item.lo_info && item.lo_info.name}
                  </Grid>

                  <div className={classes.address}>
                    <span>
                      {item.lo_info.address.depth_1} {item.lo_info.address.depth_2}
                    </span>
                    <span className={classes.verticalCenter}>
                      <Popup
                        open={openPopup[index]}
                        onOpen={() => {
                          let addressTxt = `${item.lo_info.address.depth_1} ${item.lo_info.address.depth_2}`;
                          if (window?.navigator?.clipboard?.writeText) {
                            window.navigator.clipboard.writeText(addressTxt);
                          } else {
                            copyToClipboard(addressTxt);
                          }
                          openCopiedPopup(index);
                        }}
                        trigger={
                          <button className={classes.copyIconButton}>
                            <img src={Copy} className={classes.copyIcon} alt="복사하기" />
                          </button>
                        }
                        position="bottom center"
                        close={openPopup[index]}
                        contentStyle={contentStyle}
                        // overlayStyle={overlayStyle}
                        // arrowStyle={arrowStyle}
                      >
                        {context.string.chat.clipboardCopied}
                      </Popup>
                    </span>
                    {openPopup[index] && (
                      <div
                        className={classes.copyClipDiv}
                        role="alert"
                        aria-live="assertive"
                      >
                        {context.string.chat.clipboardCopied}
                      </div>
                    )}
                  </div>
                </Grid>

                <div className={classes.infoBody}>
                  <Divider component={'div'} variant="middle" color="#eee" disabled />
                  <div className={classes.infoContainer} role={'text'}>
                    <div className={classes.infoMultilineContainer}>
                      {/* 서비스센터 찾기 카드에 출력되는 문구 변경 25-03 */}
                      {(saturdayHour === '휴무' && item.lo_type === 'kr_center') ||
                      item.lo_type === 'kr_shop'
                        ? tablerows.map((row, index) => {
                            return (
                              <Grid
                                container
                                key={`g1_${index}`}
                                className={classes.infoMultilineItem}
                              >
                                <Grid item className={classes.label}>
                                  {row.label}
                                </Grid>
                                <Grid item className={classes.infoValue}>
                                  {row.value}
                                </Grid>
                              </Grid>
                            );
                          })
                        : tablerows.map((row, index) => {
                            return (
                              <Grid
                                container
                                key={`g1_${index}`}
                                className={classes.infoMultilineItem}
                              >
                                <Grid item className={classes.label}>
                                  {row.label}
                                </Grid>
                                <Grid item className={classes.infoValue}>
                                  {row.value}
                                </Grid>
                                {row.label === '토요일' ? (
                                  <div className={classes.infoSaturdayItem}>
                                    <Grid item>&nbsp;</Grid>
                                    <Grid item className={classes.infoSaturday}>
                                      * 매월 4번째 토요일 휴무
                                    </Grid>
                                  </div>
                                ) : (
                                  ''
                                )}
                              </Grid>
                            );
                          })}
                    </div>
                  </div>
                  <Divider component={'div'} variant="middle" color="#eee" disabled />
                  <div className={classes.infoContainer} role={'text'}>
                    <div className={classes.infoMultilineContainer}>
                      <Grid
                        container
                        key={`g2_${index}`}
                        className={classes.infoMultilineItem}
                      >
                        <Grid item className={classes.label}>
                          전화
                        </Grid>
                        <Grid
                          item
                          className={[classes.infoValue, classes.callValue].join(' ')}
                        >
                          {item.lo_info.phone_number}{' '}
                          {context.userAgent.deviceType === 'mobile' &&
                            item.lo_info &&
                            item.lo_info.phone_number && (
                              // <>
                              //   <a className={classes.phoneCallLink} href={`tel:${item.lo_info.phone_number}`}>{item.lo_info.phone_number}</a>
                              //   <img src={ArrowRight} className={classes.callIcon} />
                              // </>
                              <button
                                type="button"
                                className={classes.phoneCallLink}
                                onClick={() => {
                                  handlePhoneCallClick(item.lo_info.phone_number);
                                }}
                              >
                                <img
                                  src={ArrowRight}
                                  className={classes.callIcon}
                                  alt="전화하기"
                                />
                              </button>
                            )}
                        </Grid>
                      </Grid>
                      <Grid
                        container
                        key={`g3_${index}`}
                        className={classes.infoMultilineItem}
                      >
                        <Grid item className={classes.label}>
                          주차
                        </Grid>
                        <Grid item className={classes.infoValue}>
                          {item.lo_type === 'kr_shop'
                            ? item.lo_info.parking
                            : item.lo_info.parking_detail}
                        </Grid>
                      </Grid>
                    </div>
                  </div>
                </div>
                <Grid container className={classes.buttonGroup}>
                  {item.lo_info.buttons &&
                    item.lo_info.buttons.map((button, index) => {
                      let buttonIcon = '';
                      switch (button.label) {
                        case '길찾기':
                          buttonIcon = Navigation;
                          break;
                        case '방문예약':
                        case '매장상담신청':
                          buttonIcon = Reservation;
                          break;
                        case '문자로받기':
                          buttonIcon = iconSMS;
                          break;
                        default:
                          buttonIcon = null;
                      }

                      return (
                        <Grid
                          item
                          key={`g4_${index}`}
                          // xs={12 / item.lo_info.buttons.length}
                          className={classes.buttonGroupItem}
                        >
                          {/* <Divider
                    className={classes.buttonDivider}
                    orientation="horizontal"
                    hidden={index === 0}
                    component={"div"}
                    disabled
                  /> */}
                          <button
                            type="button"
                            className={[
                              classes.button,
                              index !== 0 && classes.buttonDefault,
                              // index === 0 &&
                              //   item.lo_info.buttons.length !== 1 &&
                              //   classes.buttonLeft,
                              // index === item.lo_info.buttons.length - 1 &&
                              //   item.lo_info.buttons.length !== 1 &&
                              //   classes.buttonRight,
                              // index !== 0 &&
                              // index !== item.lo_info.buttons.length - 1 &&
                              // item.lo_info.buttons.length > 2
                              //   ? classes.buttonMiddle
                              //   : "",
                              (context.conversationEnd ||
                                button.parameters.enable === 'N') &&
                                classes.buttonDisabled,
                            ].join(' ')}
                            disabled={
                              context.conversationEnd || button.parameters.enable === 'N'
                            }
                            onClick={() => handleButtonClick(item, index)}
                            aria-label={`${
                              button.parameters.action.toLowerCase() === 'external' ||
                              button.parameters.action.toLowerCase() === 'get_direction'
                                ? context.string.aria.external + ','
                                : ''
                            } ${button.label}`}
                          >
                            {button.label}
                          </button>
                        </Grid>
                      );
                    })}
                </Grid>
              </div>
            </div>
          ) : (
            <></>
          );
        })}
      </div>
      {renderDots()}
    </EmblaCarouselReact>
  );
});

const LO = (props) => {
  const { classes, data } = props;
  const context = useContext(DataContext);
  const [selectedVal, setSelectedVal] = useState('kr_all');

  const handleChange = (e, newButtonVal) => {
    if (newButtonVal !== null) {
      console.log('Change LO Type ======================================');
      setSelectedVal(newButtonVal);
    }
  };
  const [state, setState] = useState({
    SMSOpen: false,
    centerName: '',
    centerSeq: null,
    phoneNumber: '',
  });

  const parentFunc = {
    setSMSInfo: setState,
  };

  const handleSMSOK = (data) => {
    setState((prev) => {
      return { ...prev, SMSOpen: false, phoneNumber: '' };
    });
    console.log('handleSMSOK', data);
  };

  const handleSMSClose = () => {
    setState((prev) => {
      return { ...prev, SMSOpen: false, phoneNumber: '' };
    });
  };

  // const mapData = data.items.filter(item => (selectedVal==="kr_all" || item.lo_type === selectedVal))
  const mapData = data.items;

  return (
    <>
      <div className={classes.root}>
        {data.query_type === 'kr_all' && (
          <ToggleButtonGroup
            exclusive
            classes={{ root: classes.options }}
            value={selectedVal}
            onChange={handleChange}
          >
            {btn_order.map((data, index) => (
              <ToggleButton
                key={`toggle-lo-${index}`}
                disableFocusRipple={true}
                disableRipple={true}
                value={data.lo_type}
                classes={{ root: classes.optionButton, selected: classes.btnSelected }}
              >
                {data.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        )}
        <LOCarousel data={mapData} parentFunc={parentFunc} selectedLoType={selectedVal} />
        <SMS
          open={state.SMSOpen}
          handleOk={handleSMSOK}
          handleClose={handleSMSClose}
          centerName={state.centerName}
          centerSeq={state.centerSeq}
          defaultPhoneNumber={state.phoneNumber}
        />
      </div>
    </>
  );
};
export default withStyles(styles)(LO);
